import React, { useState } from 'react';
import SigninModal from '../../modal/SigninModal';
import { kitchenService } from '../../services';
import { toast } from 'react-toastify';

export interface Form1Data {
  mobileNumber: string;
  otp?: string;
}

interface Form1Props {
  onNext: (data: Form1Data) => void;
  initialData?: Form1Data;
}

const Form1: React.FC<Form1Props> = ({ onNext, initialData }) => {
  const [mobileNumber, setMobileNumber] = useState(initialData?.mobileNumber || '');
  const [sendingOtp, setSendingOtp] = useState(false);

  const handleGetStarted = async () => {
    if (mobileNumber.length !== 10) {
      toast.error('Please enter a valid 10-digit mobile number');
      return;
    }

    setSendingOtp(true);
    try {
      const response: any = await kitchenService.sendOtp(mobileNumber);
      
      if (response.status) {
        // toast.success('OTP sent successfully!');
        // Extract OTP from response and move to next step
        const receivedOtp = response.data?.message || '';
        onNext({ mobileNumber, otp: receivedOtp });
      }
    } catch (err: any) {
      toast.error(err.message || 'Failed to send OTP');
    } finally {
      setSendingOtp(false);
    }
  };

  return (
    <div>
      <SigninModal 
        isOpen={true}
        onClose={() => {}} // Prevent closing during registration
        onGetStarted={handleGetStarted}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
      />
    </div>
  );
};

export default Form1;
